// @flow
import reducer from "./reducers";

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/index.js